<form *ngIf="form" [formGroup]="form" class="search-form">
  <app-input-field
    label="Search"
    [id]="'datasheet-search'"
    [uppercase]="true"
    formControlName="query"
    [placeholder]="placeholder"
    insideIcon="fas fa-search"
    class="col-xs-12"
  >
  </app-input-field>
</form>
